import React, { FunctionComponent } from "react";

const CheckDoubleIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/form-validation/check-double-1
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.25,4.249,11.808,19.505a1.5,1.5,0,0,1-2.261.161L6.57,16.689"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M6,19.76a1.5,1.5,0,0,1-2.133.012L.89,16.8"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M17.43 4.355L9.29 15.209"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default CheckDoubleIcon;
